import * as React from "react";

function SvgCheck(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8a8 8 0 1016 0A8 8 0 000 8zm14 0A6 6 0 112 8a6 6 0 0112 0z"
        fill="currentColor"
      />
      <path
        d="M11.707 6.707a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCheck;
